import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ViewModel from './ViewModel';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  progressContainer: {
    width: '100%',
    minWidth: '150px',
    textAlign: 'center',
    margin: theme.spacing.unit * 2,
  }
});


class CircularIndeterminate extends React.Component {
  constructor(props) {
    super(props);
    ViewModel.setIsLoading(true);
  }

  render() {
    let { classes } = this.props;

    let WaitingMessage;
    if (this.props.error) {
      ViewModel.setIsLoading(false);
      WaitingMessage = <Typography variant="body1">Erreur! <br/><Button onClick={ () => this.props.retry() }>Réessayer</Button></Typography>;
    } else if (this.props.timedOut) {
      WaitingMessage = <Typography variant="body1">Le chargement prends plus de temps que prévu... <br/><Button onClick={() => this.props.retry() }>Réessayer</Button></Typography>;
    } else if (this.props.pastDelay) {
      WaitingMessage = <Typography variant="body1">Chargement...</Typography>;
    } else {
      WaitingMessage = null;
    }

    return (
      <div className={classes.progressContainer}>
        <CircularProgress className={classes.progress} size={50} />
        {
          WaitingMessage !== null ? WaitingMessage : ''
        }
      </div>
    );
  }
}

export default withStyles(styles)(CircularIndeterminate);


// WEBPACK FOOTER //
// ./src/Loading.js